import type { Schema } from '@/types/mercury-data-types/unifiedapi';
import type { NormalizedSignal } from '../services/signals';

export enum CollectorType {
  ForumPosts = 'forum-posts',
  Telegram = 'telegram',
  ViewRansomware = 'view-ransomware',
  RansomPage = 'ransompage',
  RansomWatch = 'ransomwatch',
  RssCollector = 'rss-collector',
  IntelX = 'intelx',
  Cybint = 'cybint',
  ClusterArticles = 'cluster-articles',
}

export type SignalSourceCollectors =
  | CollectorType.ForumPosts
  | CollectorType.Telegram
  | CollectorType.ViewRansomware
  | CollectorType.RansomPage
  | CollectorType.RansomWatch
  | CollectorType.RssCollector
  | CollectorType.IntelX
  | CollectorType.Cybint
  | CollectorType.ClusterArticles;
export type SignalCredentialCollectors = 'botnetlogparser' | 'botnetlogs';
export type SignalCollectors = SignalSourceCollectors | SignalCredentialCollectors;

export type SignalEntity = NormalizedSignal & {
  sourceInformation: Schema<'SourceResponse'>;
};

export const CREDENTIALS_EXPOSURE_TYPE_MAP: Record<string, string> = {
  high_risk_host: 'Risky Hostname',
  admin_account: 'Risky User',
  high_risk_url: 'Risky URL',
};

export type ContextMessage = {
  author: string;
  date: string;
  content: string;
  current_message: boolean;
};
